<!-- Landing Page-->
<div class="container-flex px-5 mx-3" [hidden]="pageIndex!=0">
    <cv-user-list (userSelected)="getAllUserInfo($event)" (reloadData)="getUserDetails()" [usersList]="listUsers" [userProfileDTOs]="listUsersProfiles" [listProfileDTOs]="listProfileDTOs"
                  [baseGroupTypes]="baseGroupTypes" [groupNames]="groupNames" [allLDGroups]="allLDGroups" [langs]="langs"></cv-user-list>
    <!-- Loading spinner -->
    <div *ngIf="isLoading">
        <div class="imgLoading"></div>
    </div>
</div>
<!-- User Profile Page-->
<div class="container" id="page-selection" [hidden]="pageIndex==0">
    <div *ngIf="approvingDisapproving">
        <div class="imgLoading"></div>
    </div>
    <!--Back Button-->
    <div class="row px-5 pl-0">
        <div class="col-12 mt-3 ml-n3">
            <button type="button" class="btn btn-text-gray btn-icon" (click)="backEvent()">
                <svg>
                    <use href="../../../App_Themes/clearview-default/icons/utility/arrow-left.svg#arrow-left"></use>
                </svg>
                <span cvLocalizedText langSection="Users" langKey="Back_Button">Back</span>
            </button>
        </div>
    </div>
    <!--Profile Pages menu-->
    <div class="row px-5">
        <div class="col-12 d-flex justify-content-between ml-n2">
            <ul class="nav nav-tabs borderless-bottom">
                <li class="nav-item">
                    <a class="nav-link" [ngClass]="{'active': pageIndex == 1, 'notCurrentPageTab': pageIndex != 1}" (click)="changePageIndex(1)"
                       cvLocalizedText langSection="Users" langKey="Details">Details</a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" [ngClass]="{'active': pageIndex == 2, 'notCurrentPageTab': pageIndex != 2}" (click)="changePageIndex(2)"
                       cvLocalizedText langSection="Users" langKey="Attributes" *ngIf="permissions?.ShowAttr">Attributes</a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" [ngClass]="{'active': pageIndex == 3, 'notCurrentPageTab': pageIndex != 3}" (click)="changePageIndex(3)"
                       cvLocalizedText langSection="Users" langKey="Permissions" *ngIf="permissions?.ShowPerm">Permissions</a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" [ngClass]="{'active': pageIndex == 4, 'notCurrentPageTab': pageIndex != 4}" (click)="changePageIndex(4)"
                       cvLocalizedText langSection="Users" langKey="Gamification">Gamification</a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" [ngClass]="{'active': pageIndex == 5, 'notCurrentPageTab': pageIndex != 5}" (click)="changePageIndex(5)"
                       cvLocalizedText langSection="Users" langKey="Packages">Packages</a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" [ngClass]="{'active': pageIndex == 6, 'notCurrentPageTab': pageIndex != 6}" (click)="changePageIndex(6)"
                       cvLocalizedText langSection="Users" langKey="Package_Dashboard" *ngIf="permissions?.ShowDash">Dashboards</a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" [ngClass]="{'active': pageIndex == 7, 'notCurrentPageTab': pageIndex != 7}" *ngIf="accessTab" (click)="changePageIndex(7)" 
                        cvLocalizedText langSection="Users" langKey="Access">Access</a>
                </li>
            </ul>
            <button type="button" class="btn btn-secondary mr-n2" id="impersonate" *ngIf="permissions?.ImpersonateAccess"
                    (click)="impersonateUser()"
                    cvLocalizedText langSection="Users" langKey="Impersonate">
                Impersonate
            </button>
        </div>
    </div>
    <!--User Profile-->
    <div class="row pt-4 mx-5 userPage">
        <!--Shared Profile Area-->
        <div class="col-2 px-0 sharedCol ml-n2">
            <div class="profilePic" (click)="uploadingImg = true">
                <img id="profilePic_ed" class="profile_img_big"
                     [src]="(!selectedUserProfile || selectedUserProfile.ImageID == 0 )? '../App_Themes/Standard/Images/CoreTheme/Profile/default_profile.svg': '../Admin/ImageResizer.aspx?imgid='+selectedUserProfile.ImageID+'&w=auto&h=128'" 
                     (mouseenter)="isHovering=true" (mouseleave)="isHovering=false"/>
                <div class="profile_upload profile_upload_first" *ngIf="createOrWriteAccess()==true && isHovering"
                     cvLocalizedText langSection="Users" langKey="Update">Update</div>
                <div class="profile_upload" *ngIf="createOrWriteAccess() && isHovering"
                     cvLocalizedText langSection="Users" langKey="Profile_Picture">profile picture</div>
                <img src="../App_Themes/Standard/Images/CoreTheme/Camera Icon.svg" *ngIf="createOrWriteAccess()==true && isHovering"
                     class="upload_cam" />
            </div>
            <cv-image-upload *ngIf="uploadingImg" (croppedImage)="updateUserImage($event)" (close)="uploadingImg=false;"></cv-image-upload>
            <div class="d-flex flex-column border-bottom" style="padding-bottom:28px; margin-bottom:28px" *ngIf="!selectedUserProfile?.isApproved && hasPermissionToApprove">
                <div class="d-flex align-items-center mb-3">
                    <svg class="icon-20 fill-redRyder" style="margin-right: 4.5px"><use href="../App_Themes/clearview-default/icons/utility/error.svg#error"></use></svg>
                    <div class="font-size-11" style="max-width:126px" langSection="Profile_Management" langKey="User_Admin_Message">This user has requested to change their picture.</div>
                </div>
                <div class="d-flex">
                    <button type="button" class="btn btn-primary btn-sm mr-2" (click)="approveProfilePicture(selectedUserInfo.LoginID)" langSection="Profile_Management" langKey="Approve">Approve</button>
                    <button type="button" class="btn btn-secondary btn-sm" (click)="denyProfilePicture(selectedUserInfo.LoginID)" langSection="Profile_Management" langKey="Deny">Deny</button>
                </div>
            </div>
            <button type="button" class="btn btn-text" id="reset" (click)="resetPassword(selectedUserInfo.LoginID)"
                    *ngIf="createOrWriteAccess()==true" cvLocalizedText langSection="Users" langKey="Reset_Password">
                Reset Password
            </button>
            <mat-slide-toggle *ngIf="createOrWriteAccess()" class="mt-1" [(ngModel)]="selectedUserInfo.Active" (change)="switchUserProfileActive()" color="secondary">
                <div *ngIf="selectedUserInfo.Active" class="ms-label" cvLocalizedText langSection="Users" langKey="Active">Active</div>
                <div *ngIf="!selectedUserInfo.Active" class="ms-label" cvLocalizedText langSection="Users" langKey="Inactive">Inactive</div>
            </mat-slide-toggle>
            <div *ngIf="!createOrWriteAccess()" class="mt-1 mr-1">
                <div *ngIf="selectedUserInfo.Active" class="ms-label" cvLocalizedText langSection="Users" langKey="Active">Active</div>
                <div *ngIf="!selectedUserInfo.Active" class="ms-label" cvLocalizedText langSection="Users" langKey="Inactive">Inactive</div>
            </div>
        </div>
        <!--Profile Page tabber-->
        <div class="col-10 px-0 pageTabber">
            <div class="container-flex tab-content mr-n2 borderless-top">
                <div [ngSwitch]="pageIndex">
                    <div *ngSwitchCase="1">
                        <cv-details-useradmin (onSave)="getUserDetails()" [user]="selectedUserInfo" [userProfile]="selectedUserProfile" [langs]="langs"
                                              [profileDTOs]="listProfileDTOs" [baseGroupTypes]="baseGroupTypes" [groupNames]="groupNames"
                                              [ldGroups]="allLDGroups" (updateUser)="updateUser($event)"></cv-details-useradmin>
                    </div>
                    <div *ngSwitchCase="2">
                        <cv-attributes-useradmin [usersAttributes]="selectedUserAttributes" [attributeGroups]="attributesGroups"></cv-attributes-useradmin>
                    </div>
                    <div *ngSwitchCase="3">
                        <cv-permissions-useradmin [selectedLoginID]="selectedUserInfo.LoginID" [groupNames]="groupNames"></cv-permissions-useradmin>
                    </div>
                    <div *ngSwitchCase="4">
                        <cv-gamification-page [userInfo]="selectedUserInfo" [userProfile]="selectedUserProfile" [challengeWon]="selectedUserChallengeWon"
                                              [gemData]="selectedUserGemHistory" [coinData]="selectedUserCurrencyHistory"></cv-gamification-page>
                    </div>
                    <div *ngSwitchCase="5">
                        <cv-packages-useradmin [userPackages]="selectedUserPackages" ></cv-packages-useradmin>
                    </div>
                    <div *ngSwitchCase="6">
                        <cv-dashboards-useradmin [selectedUserInfo]="selectedUserInfo" [dashboards]="dashboards" [listUsers]="listUsers"></cv-dashboards-useradmin>
                    </div>
                    <div *ngSwitchCase="7">
                        <cv-access-useradmin [selectedUser]="selectedUserInfo" [selectedProfile]="mapProfileDTOs.get(selectedUserInfo.ProfileID)" [viewOnly]="pageAccessViewOnly"></cv-access-useradmin>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
